export enum ProjectDataNavItem {
  PROJECT = 'project',
  PRODUCT = 'product',
  PALLET = 'pallet',
  PALLETIZING = 'palletizing',
  SING_IN = 'sign_in',
  SIGN_UP = 'sign_up',
}
